var map = {
	"./": [
		"12cb"
	],
	"./cn": [
		"4091",
		"chunk-2d0bff8a"
	],
	"./cn/": [
		"4091",
		"chunk-2d0bff8a"
	],
	"./cn/index": [
		"4091",
		"chunk-2d0bff8a"
	],
	"./cn/index.js": [
		"4091",
		"chunk-2d0bff8a"
	],
	"./en": [
		"811a"
	],
	"./en/": [
		"811a"
	],
	"./en/index": [
		"811a"
	],
	"./en/index.js": [
		"811a"
	],
	"./index": [
		"12cb"
	],
	"./index.js": [
		"12cb"
	],
	"./vn": [
		"75f4",
		"chunk-2d0d74e2"
	],
	"./vn/": [
		"75f4",
		"chunk-2d0d74e2"
	],
	"./vn/index": [
		"75f4",
		"chunk-2d0d74e2"
	],
	"./vn/index.js": [
		"75f4",
		"chunk-2d0d74e2"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2e98";
module.exports = webpackAsyncContext;